import React from 'react';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 24,
  marginBottom: 16,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

const label = {
  fontSize: 13,
  fontWeight: 600,
  marginBottom: 6,
  display: 'block',
};

export default function DrawingTab({
  drawingFile, drawingImg, drawingName, drawingRef,
  handleDrawingUpload, runDrawingAI, aiStatus, aiLog,
}) {
  const busy = aiStatus === 'running' || aiStatus === 'loading';
  const canAnalyze = !!drawingFile && !busy;
  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      {/* File Upload */}
      <div style={card}>
        <span style={label}>Upload Drawing (JPG / PNG / PDF)</span>
        <input
          ref={drawingRef}
          type="file"
          accept=".jpg,.jpeg,.png,.pdf"
          onChange={handleDrawingUpload}
          style={{ fontSize: 13 }}
        />
        {drawingName && (
          <div style={{ marginTop: 8, fontSize: 12, color: '#64748b' }}>
            Loaded: {drawingName}
          </div>
        )}
        <div style={{ marginTop: 10, fontSize: 11, color: '#94a3b8' }}>
          Vision is proxied through the paneliq API — the team's Anthropic key stays server-side.
          PDFs: page 1 is rendered to image before analysis (multi-page coming later).
        </div>
      </div>

      {/* Preview — image uploads only */}
      {drawingImg && (
        <div style={card}>
          <span style={label}>Drawing Preview</span>
          <img
            src={'data:image/jpeg;base64,' + drawingImg}
            alt="Drawing preview"
            style={{
              maxWidth: '100%',
              maxHeight: 400,
              borderRadius: 6,
              border: '1px solid #e2e8f0',
            }}
          />
        </div>
      )}

      {/* Analyze Button */}
      <div style={card}>
        <button
          type="button"
          onClick={runDrawingAI}
          disabled={!canAnalyze}
          style={{
            fontSize: 14,
            fontWeight: 600,
            padding: '10px 24px',
            border: 'none',
            borderRadius: 6,
            color: '#fff',
            background: canAnalyze ? '#2563eb' : '#94a3b8',
            cursor: canAnalyze ? 'pointer' : 'not-allowed',
          }}
        >
          {busy ? 'Analyzing…' : 'Analyze Drawing with Claude AI'}
        </button>

        {/* Status / Log */}
        {aiLog && (
          <pre
            style={{
              marginTop: 14,
              fontSize: 12,
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 6,
              padding: 14,
              whiteSpace: 'pre-wrap',
              maxHeight: 300,
              overflowY: 'auto',
              color: '#334155',
            }}
          >
            {aiLog}
          </pre>
        )}
      </div>
    </div>
  );
}
